.grid-header {
  i {
    font-size: 16px;
    vertical-align: middle;
    display: inline-block;
    margin-right: 4px;
    line-height: 1rem;
  }

  .title {
    display: inline-block;
    vertical-align: middle;
    line-height: 1rem;
  }
}
